import React, { Component } from 'react';
import styles from '../../components/fulldescription/FullDescription.module.css';

import PlainFullDescription from '../../components/fulldescription/PlainFullDescription';

import { getCurrentResource } from '../../util/tools';
import { FORM_REQUEST_FT } from '../../util/consts/forms';
import { CLASS_REQUEST } from '../../util/consts/classes';

class RequestPage extends Component {

	constructor(props) {
		super(props);
		this.resource = getCurrentResource().pages.plain.Request;
		this.plainInfo = {
			app: props.app,
			page: this,
			class: CLASS_REQUEST,
			instanceModelId: FORM_REQUEST_FT,
			instanceId: this.props.match.params.id,
			param: {}
		};
	}

	render() {
		return (
			<React.Fragment>
				<div className={styles.divPlainTitle}>
					{this.resource.title}
				</div>
				<PlainFullDescription plain={this.plainInfo} />
			</React.Fragment>
		)
	}
}

export default RequestPage;
